import "core-js/modules/esnext.global-this.js";
/** Internal global with common properties and Sentry extensions  */

/** Get's the global object for the current JavaScript runtime */
var GLOBAL_OBJ = globalThis;
export { GLOBAL_OBJ };